export default {"src":"/_next/static/image/public/images/ic_download_blue_rounded.3693572fd792ee5d5274be53ed8d5b41.svg","height":40,"width":40};